import React from "react";
import {Link} from "react-router-dom";
import {HOME, NOT_FOUND} from "../../constants/routes";

/**
 * 404 Component
 *
 * {@description
 *      NOTE: Not possible to return a 404 from client side React as of Mar 21, 2016
 *      {@link https://github.com/ReactTraining/react-router/issues/3210}
 * }
 */
const NotFound = ({location}) => {
    return (
        <div className="container">
            <h1>404: Page Not Found</h1>
            <p>The requested URL {location.pathname !== NOT_FOUND && location.pathname} was not found on this application.</p>
            <p>Go <Link to={HOME}>home</Link>.</p>
        </div>
    );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/error/NotFound.jsx